import Axios from "axios";
import { store } from "store/store";
import { getConfig } from "../config";
import { Attachment } from "components/docSharing/filelist/AttachmentTypes";

export interface ICreateReq {
  meetingId: string;
  attachments: Attachment[];
}

export const registerAttachments = async (roomId: string, attachments: Attachment[]) => {
  try {
    const url = `${store.getState().env.value.MGR_SERVER}/api/video/meetings/attachments`;

    let data: ICreateReq = {
      meetingId: roomId,
      attachments,
    };

    const config = getConfig(store.getState().auth.token);
    const axiosInstance = Axios.create({ timeout: 30000 });

    const response = await axiosInstance.post(url, data, config);
    return { result: response.status === 200 };
  } catch (e) {
    console.log("error from manager registerAttachments api");
    console.log(e);
  }
};
